import angular from 'angular';

import CategoryIconComponent from './category-icon.cmpt';

export default angular
    .module('application.component.category-icon', [])
    .component(CategoryIconComponent.selector, CategoryIconComponent);



// WEBPACK FOOTER //
// ./src/application/component/category-icon/index.js